module.exports = __webpack_public_path__ + "static/media/car-mechanic.3efed808.svg";